import { render } from "./SettingOpacity.vue?vue&type=template&id=004a93ef"
import script from "./SettingOpacity.vue?vue&type=script&lang=js"
export * from "./SettingOpacity.vue?vue&type=script&lang=js"

import "./SettingOpacity.vue?vue&type=style&index=0&id=004a93ef&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__